<template>
  <section class="catalog" :id="category.category_id" v-if="category.products?.length > 0">
    <div class="container">
      <div class="catalog__title">
        <router-link :to="{'name':'catalog:category:page', params: {slug: category.seo_url}}">
          <h1 v-if="categoryPage"> {{ category.name }}</h1>
          <div v-else> {{ category.name }}</div>
        </router-link>
      </div>
      <div class="catalog__list">
         <TheProduct v-for="product in category.products" :key="product.product_id" :product="product"/>
      </div>
    </div>
  </section>
</template>

<script>
import TheProduct from "@/components/element/TheProduct.vue";

export default {
  name: 'TheCategoryList',
  components: {TheProduct},
  props: {
    category: {
      require: true,
    },
    categoryPage: {
      default: true,
      require: false,
    }
  },
}
</script>

